import React__default from 'react';
import { SymbolSize20 } from './svgs/SymbolSize20.es.js';
import { SymbolSize24 } from './svgs/SymbolSize24.es.js';
import { SymbolSize30 } from './svgs/SymbolSize30.es.js';
import { SymbolSize36 } from './svgs/SymbolSize36.es.js';
import { SymbolSize40 } from './svgs/SymbolSize40.es.js';
import { SymbolSize48 } from './svgs/SymbolSize48.es.js';
import { SymbolSize60 } from './svgs/SymbolSize60.es.js';
import { SymbolSize80 } from './svgs/SymbolSize80.es.js';
import { SymbolSize120 } from './svgs/SymbolSize120.es.js';
import { SymbolSize150 } from './svgs/SymbolSize150.es.js';

const getLogo = (size) => {
  switch (size) {
    case "small":
      return React__default.createElement(SymbolSize24, null);
    case "medium":
      return React__default.createElement(SymbolSize36, null);
    case "large":
      return React__default.createElement(SymbolSize48, null);
    case 20:
      return React__default.createElement(SymbolSize20, null);
    case 30:
      return React__default.createElement(SymbolSize30, null);
    case 40:
      return React__default.createElement(SymbolSize40, null);
    case 60:
      return React__default.createElement(SymbolSize60, null);
    case 80:
      return React__default.createElement(SymbolSize80, null);
    case 120:
      return React__default.createElement(SymbolSize120, null);
    case 150:
      return React__default.createElement(SymbolSize150, null);
    default:
      return React__default.createElement(SymbolSize36, null);
  }
};
const ZapierLogoSymbol = ({ size = 40 }) => {
  return getLogo(size);
};

export { ZapierLogoSymbol };
//# sourceMappingURL=ZapierLogoSymbol.es.js.map
